import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Select, TextInput, Typography, } from '@guildeducationinc/recess';
import { ActivityStatusPicker } from '@src/components/Activity/ActivityStatusPicker';
import { DateRangeFilter } from '@src/components/DateRangeFilter';
import { SlidersHorizontalIcon } from 'lucide-react';
import { TrackableButton, useBreakpoints, useDebounce, useLocale } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
import styles from './ActivityFilter.module.scss';
export const ActivityFilter = ({ show, showTitle = true, showSearch = false, showType = true, filter, onChange, titleVariant = 'h2', statusContext, }) => {
    const { t } = useLocale();
    const { isMobile } = useBreakpoints();
    const [expanded, setExpanded] = useState(false);
    const [searchText, setSearchText] = useState(filter.searchText ?? '');
    const debouncedSearch = useDebounce(searchText, 500);
    useEffect(() => {
        if (!isMobile) {
            setExpanded(true);
        }
    }, [isMobile]);
    useEffect(() => {
        if (debouncedSearch !== filter.searchText) {
            onChange({ ...filter, searchText: debouncedSearch });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearch, filter]);
    if (!show)
        return null;
    const handleChange = (prop) => (value) => {
        onChange({ ...filter, [prop]: value });
    };
    return (_jsxs("div", { className: styles.filter, children: [_jsxs("div", { className: styles.title, children: [showTitle && _jsx(Typography, { variant: titleVariant, children: t('Activity history') }), isMobile && (_jsx(TrackableButton, { enText: 'Filter', tag: 'activity_filter', appearance: 'ghost', onClick: () => setExpanded(prev => !prev), children: _jsxs("span", { className: 'flex gap-2', children: [t('Filter'), " ", _jsx(SlidersHorizontalIcon, { size: 16 })] }) }))] }), isMobile && _jsx(Divider, { opacity: '2' }), expanded && (_jsxs("div", { className: styles.criteria, children: [showSearch && (_jsx(TextInput, { className: 'grow', label: t('Search'), placeholder: t('Search by name/id'), value: searchText, onChange: e => setSearchText(e.target.value) })), _jsx(DateRangeFilter, { value: filter.dateRange, onChange: handleChange('dateRange') }), _jsx(ActivityStatusPicker, { value: filter.status, onChange: handleChange('status'), statusContext: statusContext }), showType && (_jsx(Select, { label: t('Activity Type'), placeholder: t('All types'), value: filter.type || '', onChange: e => onChange({
                            ...filter,
                            type: !e.target.value ? undefined : e.target.value,
                        }), options: [
                            { value: '', label: t('All activity') },
                            { value: 'program', label: t('Program') },
                            { value: 'payment_request', label: t('Reimbursement request') },
                        ], isClearable: false }))] }))] }));
};
